enum Keys {
  ACCESS_TOKEN_KEY = "ppt_access_token",
  ID_TOKEN_KEY = "ppt_id_token",
}

export function storeAccessToken(accessToken: string): void {
  return localStorage.setItem(Keys.ACCESS_TOKEN_KEY, accessToken)
}

export function storeIdToken(idToken: string): void {
  return localStorage.setItem(Keys.ID_TOKEN_KEY, idToken)
}

export function getAccessToken(): string | null {
  return localStorage.getItem(Keys.ACCESS_TOKEN_KEY)
}

export function getIdToken(): string | null {
  return localStorage.getItem(Keys.ID_TOKEN_KEY)
}

export function clearLocalStorage(): void {
  return localStorage.clear()
}
